export interface ICompanyLists {
	isCompanyContactFor: string[];
	isSiteHeadFor: string[];
	isCoOwnerFor: string[];
}

export function nullOrArray(array: string[]): string[] {
	return array?.length > 0 ? array : null;
}

export class CompanyLists implements ICompanyLists {
	public isCompanyContactFor: string[] = [];
	public isSiteHeadFor: string[] = [];
	public isCoOwnerFor: string[] = [];

	constructor(
		isCompanyContactFor: string[] = [],
		isSiteHeadFor: string[] = [],
		isCoOwnerFor: string[] = []
	) {
		this.isCompanyContactFor = isCompanyContactFor ?? [];
		this.isSiteHeadFor = isSiteHeadFor ?? [];
		this.isCoOwnerFor = isCoOwnerFor ?? [];
	}

	public clone(): CompanyLists {
		return new CompanyLists(
			this.isCompanyContactFor,
			this.isSiteHeadFor,
			this.isCoOwnerFor
		);
	}

	public get isCompanyContact(): boolean {
		return this.isCompanyContactFor?.length > 0;
	}

	public get isSiteHead(): boolean {
		return this.isSiteHeadFor?.length > 0;
	}

	public get isCoOwner(): boolean {
		return this.isCoOwnerFor?.length > 0;
	}

	public static hasValue(lists: CompanyLists): boolean {
		return lists.isCompanyContact || lists.isSiteHead || lists.isCoOwner;
	}

	public static clean(lists: CompanyLists): void {
		lists.isCompanyContactFor = nullOrArray(lists.isCompanyContactFor);
		lists.isSiteHeadFor = nullOrArray(lists.isSiteHeadFor);
		lists.isCoOwnerFor = nullOrArray(lists.isCoOwnerFor);
	}
}
